import React from 'react';
import {translate} from 'react-i18next';
import {Form} from 'antd';
import {compose} from "redux";
import FormList from "../../../../components/form-list";
import {connect} from "react-redux";
import LoginProviderForm from './LoginProviderForm';

const mapStateToProps = state => ({
  nodeId: state.app.endpointId
});

export const PROVIDERS = [
  "ISTATSHIBBOLETH",
];

const LoginProvidersForm = ({
                              t,
                              LoginProviders,
                              onChange,
                            }) => {

  const availableProviders = PROVIDERS
    .filter(provider => !(LoginProviders || [])
      .map(({ProviderName}) => ProviderName)
      .filter(val => val)
      .includes(provider)
    );

  return (
    <Form.Item
      label={t('data.nodesConfig.loginProviders.label')}
    >
      <FormList
        values={LoginProviders}
        Component={LoginProviderForm}
        componentProps={{
          availableProviders
        }}
        newItem={{
          AppId: null,
          AppSecret: null,
          AuthorizationURL: null,
          Enabled: true,
          GrantType: null,
          Label: null,
          LoginBaseURL: null,
          ProviderName: null,
          SuperadminMails: null,
          UserPassword: null,
          IsNewProvider: true
        }}
        addItemLabel={t('scenes.configuration.nodesConfig.loginProviders.addButton.title')}
        removeItemLabel={t('scenes.configuration.nodesConfig.loginProviders.removeButton.title')}
        onChange={onChange}
        isAddItemDisabled={availableProviders.length === 0}
      />
    </Form.Item>
  )
};

export default compose(
  translate(),
  connect(mapStateToProps)
)(LoginProvidersForm);



// WEBPACK FOOTER //
// ./src/scenes/configuration/nodes-config/node/LoginProvidersForm.jsx